export const displayWalletAddress = (address: string) => {
  if (typeof address !== "string" || address.length < 8) return address;
  return `${address.slice(0, 3)}...${address.slice(-4)}`;
};

export const FAVORITE_WALLETS_KEY = "favorite_wallets";

export const toggleFavoriteWallet = (address: string | undefined): string[] => {
  if (!address) return [];

  const current = JSON.parse(
    localStorage.getItem(FAVORITE_WALLETS_KEY) || "[]",
  );

  let updated: string[];
  if (current.includes(address)) {
    updated = current.filter((addr: string) => addr !== address);
  } else {
    updated = [address, ...current].slice(0, 50);
  }

  localStorage.setItem(FAVORITE_WALLETS_KEY, JSON.stringify(updated));
  return updated;
};

export const getFavoriteWallets = (): string[] => {
  return JSON.parse(localStorage.getItem(FAVORITE_WALLETS_KEY) || "[]");
};

export const isWalletFavorite = (address: string): boolean => {
  const favorites = getFavoriteWallets();
  return favorites.includes(address);
};
